<template>
  <div class="checkout">
    <h2 class="checkout__title">帳務資訊</h2>
    <div class="columns">
      <div class="column is-7">
        <div class="box">
          <h3 class="box__title">基本資訊</h3>
          <div class="columns is-flex-wrap-wrap">
            <div
              v-for="field in fields"
              :key="`field-${field.label}`"
              class="column is-full">
              <b-field
                horizontal>
                <span slot="label" :class="{ required: field.required }">
                  {{ field.label }}
                </span>
                <b-input v-model="form[field.key]" />
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-5">
        <div class="box preview">
          <h3 class="box__title">
            <span>您的方案</span>
            <small>標準方案</small>
          </h3>
          <hr>
          <div class="preview__row">
            <span>即日起啟用</span>
            <span>每人 {{ pricePerMember }}元/月*</span>
          </div>
          <div class="preview__row">
            <span>下次出帳日期</span>
            <span>{{ nextPaymentDate }}</span>
          </div>
          <div class="preview__terms">
            <b-checkbox v-model="termsAgreed">
              同意每月依照啟用中帳號收費
            </b-checkbox>
            <b-button
              type="is-primary"
              class="mt-5"
              expanded
              :disabled="upgradingUnavailable"
              @click="onSubmit">
              升級方案
            </b-button>
            <p class="preview__note">*依照每月實際啟用組織成員數收費。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkout from './Checkout';

export default Checkout;
</script>

<style lang="scss" scoped>
@import 'Checkout';
</style>
